export const ADMIN_PRIVILEGES = {
  CAN_VIEW: 'VIEW.CAN_VIEW_ADMIN_DASHBOARD',
  OVERVIEW: 'VIEW.ADMIN_DASHBOARD.OVERVIEW',
  MARKETING: 'VIEW.ADMIN_DASHBOARD.MARKETING',
  ANALYZE: 'VIEW.ADMIN_DASHBOARD.ANALYZE',
  COMMUNICATE: 'VIEW.ADMIN_DASHBOARD.COMMUNICATE',
  AUTOMATE: 'VIEW.ADMIN_DASHBOARD.AUTOMATE',
  STAFFING: 'VIEW.ADMIN_DASHBOARD.STAFFING',
  SYSTEM: 'VIEW.ADMIN_DASHBOARD.SYSTEM',
  COMPANY: 'VIEW.ADMIN_DASHBOARD.COMPANY',
  FINANCES: 'VIEW.ADMIN_DASHBOARD.FINANCES',
  LAYOUT: 'VIEW.ADMIN_DASHBOARD.LAYOUT',
  CUSTOM_VIEWS: 'VIEW.ADMIN_DASHBOARD.CUSTOM_VIEWS',
  DEVELOPERS: 'VIEW.ADMIN_DASHBOARD.DEVELOPERS',
  AI: 'VIEW.AI',
  TRAINING: 'VIEW.ADMIN_DASHBOARD.TRAINING',
  MODULE_PAGES: 'VIEW.MODULE_PAGES',
} as const

export type AdminPrivilege = typeof ADMIN_PRIVILEGES[keyof typeof ADMIN_PRIVILEGES]
